export default __webpack_public_path__ + "static/media/B2B.7714841c.png";